import React, { useState } from 'react';

export function SetPasswordPage({ profile, onSetPassword }) {
  const [pw, setPw]         = useState('');
  const [pw2, setPw2]       = useState('');
  const [err, setErr]       = useState('');
  const [saving, setSaving] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    if (pw.length < 6) return setErr('Password must be at least 6 characters.');
    if (pw !== pw2) return setErr("Passwords don't match.");
    setSaving(true);
    setErr('');
    try {
      await onSetPassword(pw);
    } catch (e) {
      setErr(e.message || 'Failed to set password');
    }
    setSaving(false);
  }

  return (
    <div className="login-bg">
      <div className="login-card">
        <div className="login-title">Welcome, <em>{profile.name?.split(' ')[0]}</em></div>
        <div className="login-sub">Set your password to get started</div>

        <form onSubmit={handleSubmit}>
          <div className="fgrp">
            <label className="flbl">New Password</label>
            <input className="finp" type="password" value={pw} onChange={e => setPw(e.target.value)} placeholder="Min 6 characters" />
          </div>
          <div className="fgrp">
            <label className="flbl">Confirm Password</label>
            <input className="finp" type="password" value={pw2} onChange={e => setPw2(e.target.value)} placeholder="Type it again" />
          </div>
          {err && <div className="err">{err}</div>}
          <button className="btn" type="submit" disabled={saving} style={{ width: '100%', marginTop: 8 }}>
            {saving ? 'Saving…' : 'Set Password & Continue →'}
          </button>
        </form>
      </div>
    </div>
  );
}
